/***
 *
 *   TEAM SELECTOR
 *   Dropdown to choose which account/team's data to view.
 *   Renders only when the user belongs to more than one account.
 *
 **********/

import { useContext } from "react";
import { AuthContext } from "components/lib";

export function TeamSelector({ value, onChange, className = "" }) {
  const authContext = useContext(AuthContext);
  const accounts = authContext.user?.accounts || [];

  // nothing to switch between
  if (accounts.length < 2) return null;

  return (
    <div className={`mb-4 flex items-center gap-2 ${className}`}>
      <label className="text-sm text-white/60 poppins-light">Team</label>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="bg-transparent dark:text-white text-[#02172C] border border-[#F2F2F2] dark:border-white/15 rounded-md px-3 py-1.5 text-sm focus:outline-none focus:ring-0"
      >
        {accounts.map((a) => (
          <option key={a.id} value={a.id} className="text-black">
            {a.name} ({a.permission})
          </option>
        ))}
      </select>
    </div>
  );
}
